// API Configuration that works for both build-time and runtime
export const getApiBaseUrl = (): string => {
  // Force localhost for development
  if (import.meta.env.DEV) {
    return 'http://localhost:8000';
  }
  
  // Check for runtime environment variable first (for manual deployment)
  if (typeof window !== 'undefined') {
    // Check if we're in production and have a runtime config
    const runtimeConfig = (window as any).__RUNTIME_CONFIG__;
    if (runtimeConfig?.VITE_API_URL) {
      return runtimeConfig.VITE_API_URL;
    }
  }
  
  // Fallback to build-time environment variable or production URL
  return import.meta.env.VITE_API_URL || 'https://designinspire.onrender.com';
};

export const API_BASE_URL = getApiBaseUrl();

// Log the API URL for debugging
if (typeof window !== 'undefined') {
}
